module.exports = __webpack_public_path__ + "img/logout.7cdce7e3.png";